<template>
  <q-card
    flat bordered
  >
    <q-card-section
        class="q-pa-sm row justify-between items-center text-bold bg-primary text-white"
    >
       Weekly Total
    </q-card-section>
    <q-separator />
    <q-card-section>
      <q-markup-table>
        <thead>
          <tr>
            <th class="text-left">Day of Week</th>
            <th class="text-left">Work Hours</th>
            <th class="text-left">Break Hours</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="{date, workHours, breakHours} in weeklyData" :key="date">
            <td class="text-left"><strong>{{date}}</strong></td>
            <td class="text-left">{{workHours}}</td>
            <td class="text-left">{{breakHours}}</td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-card-section>
  </q-card>
</template>
<script>
import graphql from '@client/graphql';

export default {
  name: 'AppClockWeeklySummary',
  components: {
  },
  apollo: {
      weeklySummary: {
        query: graphql.queries.weeklySummary,
        watchLoading(isLoading) {
          this.isLoading = isLoading;
        },
        result(result) {
          this.weeklyData = result?.data?.weeklySummary;
        }
      }
    },
  data() {
    return {
      weeklyData: [],
      isLoading: false
    };
  },
  methods: {
  }
};
</script>
<style lang="scss">
</style>
